import { useScrollAnim } from "src/hooks/hooks"

function SectionNotFound({
  sectionName,
  title = "Not Found",
  text = "Try again",
}) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className={`sc-not-found ${sectionName} w-100`} ref={trigger}>
      <div className="py-main">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h3 className={`text-center ${anim(2)}`}>{title}</h3>
          <p className={`text-center ${anim(3)}`}>{text}</p>
        </div>
      </div>
    </section>
  )
}

export default SectionNotFound
